import { Component, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { MdDialog } from '@angular/material';
import { Router, ActivatedRoute, } from '@angular/router';
import { Diagnostico } from '../../../../models';
import { TdDialogService, TdLoadingService, } from '@covalent/core';
import { DiagnosticosService, LoginService, MasterService, } from '../../../../services/';

@Component({
  selector: 'qs-diagnostico',
  styleUrls: ['./diagnosticosdetalle.component.scss'],
  templateUrl: './diagnosticosdetalle.component.html',
  viewProviders: [DiagnosticosService, MasterService],
})

export class DiagnosticosDetalleComponent implements AfterViewInit {

  public diagnostico: Diagnostico;
  public fecha: string = '';
  public hora: string = '';

  constructor(private _loginService: LoginService,
    private _diagnosticosService: DiagnosticosService,
    private _loadingService: TdLoadingService,
    private _master: MasterService,
    private _dialogService: TdDialogService,
    private _router: Router,
    private _route: ActivatedRoute,
    private _changeDetector: ChangeDetectorRef) { }

  close(): void {
    this._dialogService.closeAll();
  }

  ngAfterViewInit(): void {
    let f: any = new Date();
    this.fecha = ('00' + f.getDate()).slice(-2) + '/' + ('00' + (f.getMonth() + 1)).slice(-2) + '/' + f.getFullYear();
    this._changeDetector.detectChanges();
  }

  save(): void {
    let message: string = 'Diagnóstico añadido correctamente.';
    let action: string = 'Ok';
    let duration: number = 3000;
    let route: string = '/main/consulta/' + this._loginService.consulta.numeroExpediente + '/diagnosticos/';
    this._dialogService.openConfirm({
      message: 'Pulse ACEPTAR para añadir el diagnóstico.',
      disableClose: true,
      title: 'Añadir diagnóstico',
      cancelButton: 'Cancelar',
      acceptButton: 'Aceptar',
    }).afterClosed().subscribe((accept: boolean) => {
      if (accept) {
        let params: any = {
          lVisita: this._loginService.consulta.visita,
          lContador: this._loginService.consulta.numeroExpediente,
          lDniMed: this._loginService.profesional.Dni,
          lCias: this._loginService.cias,
          lCip: this._loginService.consulta.cip,
          lDiagnos: { string: this.diagnostico.ENFERMEDAD },
          iDescripcion: this.diagnostico.DESCRIPCION,
          iIdModulo: 0,
          iIDEpisodio: this.diagnostico.EPISODIO,
          iNumVisitaAnterior: this.diagnostico.NUM_VISITA,
        };
        this._loadingService.register();
        this._diagnosticosService.nuevoDiagnosticoPaciente(params).subscribe((res: any) => {
          if (res) {
            this._loginService.mostrarMensaje(message, action, duration);
            this._dialogService.closeAll();
            this._router.navigate([route]);
            this._loadingService.resolve();
          } else {
            this._loginService.mostrarMensaje('Error añadiendo el diagnóstico.', action, duration);
            this._dialogService.closeAll();
            this._router.navigate([route]);
            this._loadingService.resolve();
          }
        }, (error: Error) => {
          this._loginService.mostrarMensaje('Error en servicio de diagnósticos.', action, duration);
          this._loadingService.resolve();
        });
      }
    });
  }

  cerrarDiagnostico(): void {
    let message: string = 'Diagnóstico cerrado correctamente.';
    let action: string = 'Ok';
    let duration: number = 3000;
    let route: string = '/main/consulta/' + this._loginService.consulta.numeroExpediente + '/diagnosticos/';
    this._dialogService.openConfirm({
      message: 'Pulse ACEPTAR para cerrar el diagnóstico.',
      disableClose: true,
      title: 'Cerrar diagnóstico',
      cancelButton: 'Cancelar',
      acceptButton: 'Aceptar',
    }).afterClosed().subscribe((accept: boolean) => {
      if (accept) {
        let params: any = {
          iNumExpediente: this._loginService.consulta.numeroExpediente,
          iIDEpisodio: this.diagnostico.EPISODIO,
          iFechaCierre: this.fecha,
          iCcie9: this.diagnostico.CCIE9,
          iNumVisitaAlcanzado: this._loginService.consulta.visita,
          iNifUsuario: this._loginService.profesional.Dni,
        };
        this._loadingService.register();
        this._diagnosticosService.cerrarDiagnosticoPaciente(params).subscribe((res: any) => {
          if (res) {
            this._loginService.mostrarMensaje(message, action, duration);
            this._dialogService.closeAll();
            this._router.navigate([route]);
            this._loadingService.resolve();
          } else {
            this._loginService.mostrarMensaje('Error cerrando el diagnóstico.', action, duration);
            this._dialogService.closeAll();
            this._router.navigate([route]);
            this._loadingService.resolve();
          }
        }, (error: Error) => {
          this._loginService.mostrarMensaje('Error en servicio de diagnósticos.', action, duration);
          this._loadingService.resolve();
        });
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/consulta/diagnosticos/diagnosticosdetalle/diagnosticosdetalle.component.ts